import { render, staticRenderFns } from "./WPTextfieldPassword.vue?vue&type=template&id=12c2ce44"
import script from "./WPTextfieldPassword.vue?vue&type=script&lang=ts"
export * from "./WPTextfieldPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports